import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import close from '../../../../assets/V2-images/close.svg';
import { ButtonC } from 'Common/Buttons';
import InputC from 'Common/Inputs/index.tsx';
import { ReactMultiEmail } from 'react-multi-email';
import { DAM_SVG } from 'components/Dam/DamAssets';
import DateRangePicker from './DateRangePicker';
import sharelinkimg from '../../../../assets/V2-images/sharelink.png';
import { Sharedata } from 'components/Dam/DAM_API/urls';
import Axios, { header } from 'functions/Axios';
import { toast } from 'react-toastify';
import moment from 'moment';
const getUserTimezone = () => {
  const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date();
  const offset = -date.getTimezoneOffset() / 60; // Convert minutes to hours
  const isdst = new Date().getMonth() > 2 && new Date().getMonth() < 10; // Approximation for DST
  const abbr = systemTimezone.split('/').pop(); // Simple abbreviation from timezone name

  return {
    value: systemTimezone,
    label: `(UTC${offset >= 0 ? `+${offset}` : offset}:00) ${systemTimezone}`,
    offset: offset,
    abbrev: abbr,
    altName: systemTimezone,
  };
};
function getDaysDifference(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Difference in milliseconds
  const diffInMs = Math.abs(d2 - d1);

  // Convert milliseconds to days
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
}

function addDaysToDate(date, days) {
  const result = new Date(date); // create copy of given date
  result.setDate(result.getDate() + days); // add days
  return result;
}
const ShareAssetSection = ({
  openModal = false,
  toggleOpenModal,
  Header = 'Share Asset',
  ParentId,
  ParentValues,
  AssetInfo,
  HandleSave,
  shareType = 0,
}) => {
  const [openModalData, setOpenModalData] = useState(openModal);
  const [formValues, setFormValues] = useState({
    access: 1,
    expiration: 1,
    authenticated: false,
    userTimeZone: getUserTimezone(),
  });
  const [emails, setEmails] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [showlink, setShowLink] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [shareTypeValue, setShareTypeValue] = useState(shareType);
  const [loader, setLoader] = useState(false);
  const handleChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleEmailChange = (emails) => {
    setEmails(emails);
  };

  const Copylink = (damFileId, url) => {
    try {
      if (url) {
        navigator.clipboard
          .writeText(url)
          .then(() => {
            toast.success('Copied Successfully'); // Moved toast.success here
          })
          .catch((error) => {
            console.error('Failed to copy URL:', error);
            toast.error('Copy Failed'); // Moved toast.error here
          });
        return;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleShare = async () => {
    console.log('line no 102');
    setLoader(true);
    const prev_emails = ParentValues?.shareEmails;
    const new_emails = emails;
    const difference = prev_emails?.filter((item) => !new_emails.includes(item));
    try {
      const data_assets_id = ParentId;
      const response = await Axios.post(Sharedata, {
        assetId: data_assets_id,
        expiryDate:
          formValues?.expiration === 1
            ? ''
            : formValues?.expiration === 5
              ? moment(endDate).format('YYYY-MM-DD HH:mm:ss')
              : moment(
                  addDaysToDate(
                    new Date(),
                    formValues?.expiration === 2 ? 1 : formValues?.expiration === 3 ? 3 : 7,
                  ),
                ).format('YYYY-MM-DD HH:mm:ss'),
        startedDate:
          formValues?.expiration === 1
            ? ''
            : formValues?.expiration === 5
              ? moment(startDate).format('YYYY-MM-DD HH:mm:ss')
              : moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        shareType: shareTypeValue,
        neverExpire: formValues?.expiration === 1,
        assetStatus: formValues?.access === 1 ? 0 : 1,
        timezone: formValues?.userTimeZone?.value,
        ...(formValues?.access === 2 && {
          allowAccessEmails: emails,
        }),
        ...(difference?.length > 0 && {
          removeAccessEmails: difference,
        }),
        authenticated: formValues.authenticated ?? false,
        ...(ParentValues?.shareUniqueId && {
          shareUniqueId: ParentValues?.shareUniqueId,
        }),
        ...(ParentValues?.secureUrl && {
          secureUrl: ParentValues?.secureUrl,
        }),
      });
      HandleSave && HandleSave();
      toast.success(response?.data?.message);
      setShowLink(response?.data?.data?.message);
      setLoader(false);
    } catch (err) {
      setLoader(false);

      console.error(err);
    }
  };

  const formValidation = () => {
    let formIsValid = true;
  };

  const closeBtn = (
    <img
      src={close}
      alt="close"
      className="close"
      style={{ cursor: 'pointer' }}
      onClick={toggleOpenModal}
    />
  );

  const modalToggles = () => {
    toggleOpenModal(!openModalData);
    setOpenModalData(!openModalData);
  };

  useEffect(() => {
    if (AssetInfo?.Alldata) {
      setFormValues((prev) => ({
        ...prev,
        access: AssetInfo?.Alldata?.isPrivate ? 2 : 1,
        authenticated: AssetInfo?.Alldata?.authenticate ?? false,
        expiration: AssetInfo?.Alldata?.neverExpire
          ? 1
          : getDaysDifference(AssetInfo?.Alldata?.startedDate, AssetInfo?.Alldata?.expiryDate) === 1
            ? 2
            : getDaysDifference(AssetInfo?.Alldata?.startedDate, AssetInfo?.Alldata?.expiryDate) ===
                3
              ? 3
              : getDaysDifference(
                    AssetInfo?.Alldata?.startedDate,
                    AssetInfo?.Alldata?.expiryDate,
                  ) === 7
                ? 4
                : getDaysDifference(
                      AssetInfo?.Alldata?.startedDate,
                      AssetInfo?.Alldata?.expiryDate,
                    ) > 7
                  ? 5
                  : 1,
      }));
      AssetInfo?.Alldata?.startedDate &&
        !AssetInfo?.Alldata?.neverExpire &&
        setStartDate(new Date(AssetInfo?.Alldata?.startedDate));
      AssetInfo?.Alldata?.expiryDate &&
        !AssetInfo?.Alldata?.neverExpire &&
        setEndDate(new Date(AssetInfo?.Alldata?.expiryDate));

      setEmails(AssetInfo?.Alldata?.shareEmails);
      setShareTypeValue(AssetInfo?.Alldata?.shareType);
    }
  }, [AssetInfo]);

  return (
    <Modal
      isOpen={openModalData}
      toggle={modalToggles}
      style={{ maxWidth: '652px', width: '652px' }}
    >
      <ModalHeader toggle={modalToggles} close={closeBtn} className="modal_header_2nd_version">
        {Header}
      </ModalHeader>

      <ModalBody>
        {showlink ? (
          <div>
            <div id="bodyshare">
              <div style={{ width: '100%', position: 'relative' }}>
                <InputC
                  type="text"
                  label="Link"
                  name="textvalue"
                  inputvalue={showlink}
                  disabled={true}
                  // change={(e) => handleChange(e)}
                />
                <div
                  style={{
                    position: 'absolute',
                  }}
                ></div>
              </div>
              <div
                className="d-flex gap-2  absolute"
                style={{
                  position: 'absolute',
                  right: 10,
                  bottom: '10%',
                  backgroundColor: '#F2F2F2',
                  padding: '4px',
                  borderRadius: '12px',
                }}
              >
                <img src={sharelinkimg} alt="sharelink" />
                <div className="buttonshare cursor-pointer" onClick={() => Copylink('', showlink)}>
                  Copy Link
                </div>
              </div>
            </div>
          </div>
        ) : (
          <form className="dis_grid" style={{ gap: '1.5rem' }} onSubmit={handleSubmit}>
            <InputC
              type="select"
              label="Access"
              name="access"
              options={[
                { id: 1, label: 'Anyone with the link', value: 1 },
                { id: 2, label: 'Invite only', value: 2 },
              ]}
              isClearable={false}
              inputvalue={formValues.access}
              change={(e) => handleChange('access', e.value)}
            />

            {formValues?.access === 2 && (
              <div
                style={{
                  display: 'grid',
                  gap: '1rem',
                }}
              >
                <div className="checkbox-container">
                  <label className="custom-label">Invite Members</label>
                  <ReactMultiEmail
                    emails={emails}
                    onChange={handleEmailChange}
                    getLabel={(email, index, removeEmail) => (
                      <div
                        data-tag
                        key={index}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '0px 16px',
                          // margin: '5px',
                          backgroundColor: '#fdfdfd',
                          borderRadius: '40px',
                          border: '1px solid #EDEDED',
                          height: '32px',
                        }}
                        className="share_asset_2nd_version_email_select"
                      >
                        {email}
                        <span
                          data-tag-handle
                          onClick={() => removeEmail(index)}
                          style={{ marginLeft: '10px', cursor: 'pointer', color: 'red' }}
                        >
                          {DAM_SVG?.closeSvgIconBlack}
                        </span>
                      </div>
                    )}
                    style={{
                      padding: emails?.length > 0 ? '10px 12px' : '',
                    }}
                  />
                </div>
                <div className="" style={{ display: 'flex' }}>
                  <InputC
                    className="draft-checkboxes"
                    type="Checkbox"
                    change={(e) => handleChange('authenticated', e.target.checked)}
                    checked={formValues.authenticated} // Optional: to control the checked state
                    inputvalue={formValues.authenticated} // Authenticated Value line no 319
                  />

                  <div className="authenticator_label">Enable Authentication</div>
                </div>
              </div>
            )}

            <div style={{ width: '48%' }}>
              <InputC
                type="select"
                label="Link expiration"
                name="expiration"
                options={[
                  { id: 1, label: 'Never Expire', value: 1 },
                  { id: 2, label: '1 day', value: 2 },
                  { id: 3, label: '3 days', value: 3 },
                  { id: 4, label: '7 days', value: 4 },
                  { id: 5, label: 'Custom', value: 5 },
                ]}
                isClearable={false}
                inputvalue={formValues.expiration}
                change={(e) => handleChange('expiration', e.value)}
              />
            </div>
            {formValues.expiration === 5 && (
              <div
                style={{
                  display: 'grid',
                  gap: '1rem',
                }}
                className="grid_cols_6"
              >
                <div className="col_span_3">
                  {' '}
                  <DateRangePicker
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                  />
                </div>

                <div className="col_span_3">
                  <InputC
                    type="timeZone"
                    change={(e) => {
                      // setUserTimeZone(e);
                      handleChange('userTimeZone', e);
                    }}
                    label={'Timezone'}
                    // error={error?.userTimeZone}
                    inputvalue={formValues?.userTimeZone}
                    // inputvalue={
                    //   expitetime?.startTime
                    //     ? moment(expitetime?.startTime, 'HH:mm').format('HH:mm:ss')
                    //     : ''
                    // }
                  />
                </div>
              </div>
            )}
          </form>
        )}
      </ModalBody>

      <ModalFooter style={{ borderTop: 'none' }}>
        {!showlink ? (
          <div className="d-flex gap-2">
            {' '}
            <ButtonC text="Cancel" color="Secondary" size="lg" click={toggleOpenModal} />
            <ButtonC text="" size="lg" click={handleShare} disabled={loader}>
              {' '}
              {loader && <Spinner color="light" className="mx-1" size="sm" />} Generate Link
            </ButtonC>
          </div>
        ) : (
          <div>
            <ButtonC text="Done" size="lg" click={toggleOpenModal} />
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ShareAssetSection;
